import {getConfig} from '../../getConfig';
import {HandlerError} from './types';
import {isResponse} from './types.guard';

const {extensionId} = getConfig();

export const sendMessageToExtension = <P, R>(type: string, payload: P): Promise<R | null> => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!chrome?.runtime?.sendMessage) {
    return Promise.resolve(null);
  }

  // not using Promisified version of sendMessage because of potential problems with chrome.runtime.lastError
  return new Promise((resolve, reject) => {
    try {
      chrome.runtime.sendMessage(extensionId, {type, payload}, {includeTlsChannelId: true}, res => {
        if (chrome.runtime.lastError) {
          reject(chrome.runtime.lastError);
          return;
        }
        if (!isResponse(res)) {
          reject(new HandlerError('Invalid response type'));
          return;
        }
        if (!res.success) {
          reject(new HandlerError(res.errorMessage));
          return;
        }
        resolve(res.payload as R);
        return;
      });
    } catch (err) {
      reject(err);
      return;
    }
  });
};
